import './TeacherSkillsHeatmap.css'

function pct(value) {
  return Math.max(0, Math.min(100, Math.round(Number(value) || 0)))
}

function toneClass(value) {
  if (value >= 80) return 'excellent'
  if (value >= 60) return 'correct'
  if (value >= 40) return 'fragile'
  return 'critical'
}

function TeacherSkillsHeatmap({ rows }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return (
      <div className="teacher-skills-heatmap-empty">
        Pas assez de donnees pour afficher la heatmap des competences.
      </div>
    )
  }

  return (
    <div className="teacher-skills-heatmap">
      <div className="teacher-skills-heatmap-head">
        <span>Competence</span>
        <span>Reussite</span>
        <span>Volume</span>
      </div>
      <ul className="teacher-skills-heatmap-list">
        {rows.map((row) => {
          const success = pct(row.successRate)
          const tone = toneClass(success)
          return (
            <li key={row.key} className={`teacher-skills-heatmap-row ${tone}`}>
              <span className="teacher-skills-heatmap-label">{row.label}</span>
              <span className="teacher-skills-heatmap-score">{success}%</span>
              <span className="teacher-skills-heatmap-count">{row.total}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TeacherSkillsHeatmap
